import {useState} from 'react';
import {usePageText} from '../context/page-text-context';
import Icon from './icon';
import {PrintIcon} from './svgs/print-icon';
import {StyledPrintButton} from './buttons';
import {useReceiptApiSliceMutation} from '../features/api/receiptApiSlice';

const MenuItem = ({onClick, children}) => (
  <div className="py-2 px-4 text-sm select-none cursor-pointer hover:bg-primary" onClick={onClick}>
    {children}
  </div>
);

function PrintButton({printIntakeEnabled, printReleaseEnabled, claimId}) {
  const [receiptApiSlice] = useReceiptApiSliceMutation();

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const {printButton, intakePrint, releasePrint} = usePageText();

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const printForm = (htmlContent) => {
    const iframe = document.createElement('iframe');

    Object.assign(iframe.style, {
      position: 'absolute',
      width: '0',
      height: '0',
      border: 'none',
    });

    document.body.appendChild(iframe);
    iframe.srcdoc = htmlContent;

    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    }, 100);
  };

  const printIntakeOrRelease = async (formType) => {
    try {
      const html = await receiptApiSlice({formType, claimId});
      printForm(html.data);
    } catch (error) {
      console.error('Error printing intake form:', error);
    }
  };

  if (!printIntakeEnabled && !printReleaseEnabled) {
    return null;
  }

  return (
    <div style={{position: 'relative', display: 'inline-block'}}>
      <StyledPrintButton onClick={toggleDropdown}>
        <PrintIcon />
        <div className="ml-1">{printButton}</div>
        <Icon className="text-xs">Open</Icon>
      </StyledPrintButton>

      {dropdownVisible && (
        <div className="absolute top-full mt-1 right-0 w-full bg-white border border-gray rounded-sm shadow-lg z-50">
          {printIntakeEnabled ? (
            <MenuItem onClick={() => printIntakeOrRelease('intake')}>{intakePrint}</MenuItem>
          ) : null}
          {printReleaseEnabled ? (
            <MenuItem onClick={() => printIntakeOrRelease('release')}>{releasePrint}</MenuItem>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default PrintButton;
